import { createContext } from 'react';

import { Metadata } from '../../../shared/models/survey/Metadata';
import Survey from '../../../shared/models/survey/Survey';
import SurveyAnswer from '../../../shared/models/survey/SurveyAnswer';
import SurveyQuestion from '../../../shared/models/survey/SurveyQuestion';
import { SurveyContextType } from '../types';

const SurveyContext = createContext<SurveyContextType>({
  email: '',
  questionAnswers: [] as SurveyAnswer[],
  questionNumber: 0,
  survey: undefined,
  activationCode: '',
  sessionKey: '',
  question: null,
  setQuestion: (question: SurveyQuestion | null) => {
    throw new Error(`setQuestion has not yet been implemented, question: ${question}`);
  },
  setQuestionAnswer: (questionAnswer: SurveyAnswer) => {
    throw new Error(
      `updateQuestionAnswer has not yet been implemented, questionAnswer: ${JSON.stringify(questionAnswer)}`
    );
  },
  updateQuestionAnswers: (questionAnswers: SurveyAnswer[]) => {
    throw new Error(`setQuestionAnswers has not yet been implemented, questionAnswers: ${questionAnswers}`);
  },
  setBackupQuestionAnswers: (questionAnswers: SurveyAnswer[]) => {
    throw new Error(`setBackupQuestionAnswers has not yet been implemented, questionAnswers: ${questionAnswers}`);
  },
  getBackupQuestionAnswers: () => {
    throw new Error('getBackupQuestionAnswers has not yet been implemented');
  },
  setQuestionNumber: (questionNumber: number) => {
    throw new Error(`setQuestionNumber has not yet been implemented, questionNumber: ${questionNumber}`);
  },
  setEmailAddress: (email: string) => {
    throw new Error(`setEmailAddress has not yet been implemented, email: ${email}`);
  },
  updateSurvey: (survey: Survey) => {
    throw new Error(`updateSurvey has not yet been implemented, survey: ${JSON.stringify(survey)}`);
  },
  removeAnswers: () => {
    throw new Error('removeAnswers has not yet been implemented');
  },
  setAllAnswers: () => {
    throw new Error('setAllAnswers has not yet been implemented');
  },
  updateActivationCode: (code: string | null) => {
    throw new Error(`updateActivationCode has not yet been implemented, code: ${code}`);
  },
  resetAnswers: () => {
    throw new Error('resetAnswers has not yet been implemented');
  },
  updateSessionKey: (key: string) => {
    throw new Error(`updateSessionKey has not yet been implemented, key: ${key}`);
  },
  getAdvice: (identifier: string, isPositive: boolean) => {
    throw new Error(`getAdvice has not yet been implemented, identifier: ${identifier}, isPositive: ${isPositive}`);
  },
  getThemeName: (identifier: string) => {
    throw new Error(`getThemeName has not yet been implemented, identifier: ${identifier}`);
  },
  getLink: (identifier: string) => {
    throw new Error(`getLink has not yet been implemented, identifier: ${identifier}`);
  },
  onHandleNext: (finishedCallback?: () => void) => {
    throw new Error(`onHandleNext has not yet been implemented, finishedCallback: ${finishedCallback}`);
  },
  onHandlePrevious: () => {
    throw new Error('onHandlePrevious has not yet been implemented');
  },
  updateMetadata: (metadata: Metadata) => {
    throw new Error(`updateMetadata has not yet been implemented, metadata: ${JSON.stringify(metadata)}`);
  },
  getMetadata: (identifier: string) => {
    throw new Error(`getMetadata has not yet been implemented, identifier: ${identifier}`);
  },
});

export default SurveyContext;
